module.exports = __webpack_public_path__ + "img/paysolutionlogo.6df85be2.png";